angular.module('wbDashboard').run(
    ['$rootScope', '$state', '$stateParams', '$transitions', '$q', '$timeout', '$window', '$location', '$trace', 'Auth', 'User', 'Message', 'Display', 'CommonConstant', 'Track',
function ($rootScope, $state, $stateParams, $transitions, $q, $timeout, $window, $location, $trace, Auth, User, Message, Display, CommonConstant, Track) {
    // $trace.enable('TRANSITION');
    // $transitions.onBefore({}, function(trans) {
    //     $transitions.existingTrans = trans;
    // });
    $transitions.onStart({}, function(trans) {
        var requireLogin = trans.$to().data.requireLogin;

        var $to = trans.$to();
        var $from = trans.$from();

        if (requireLogin) {
            Auth.setTarget($to.name, trans.params("to"));
            if (!Auth.isLoggedIn()) {
                if ($location.search()['referrer_token']) { // jshint ignore:line
                    return trans.router.stateService.target('base.redirected');
                } else {
                    return trans.router.stateService.target('public.logout', {message: null});
                }
            }
        }

        var redirect;
        //only allow users with closed accounts to access certain pages
        if (User.getOverview()) {
            redirect = redirectIfDisabled(User.getOverview());
            if (redirect) { return redirect; }
        } else {
            User.getOverviewPromise().then(function(overview) {
                redirect = redirectIfDisabled(overview);
                if (redirect) {
                    $state.go(redirect.name(), redirect.params());
                }
            });
        }
        function redirectIfDisabled(overview) {
            if ((overview.user.is_closed && !validClosedAccountUrl($to.name)) || (!overview.user.is_closed && !validAccountUrl($to.name))) {
                let message = 'Sorry, we\'re unable to display that page.';
                if (overview.user.is_closed) {
                    message = 'Sorry, we\'re unable to display that page on a closed account.';
                }
                Message.add({
                    key: 'invalid-page',
                    text: message,
                    type: 'warning',
                });
                if ($state.transition) {
                    if ( $from.name && ( (overview.user.is_closed && validClosedAccountUrl($from.name)) || (!overview.user.is_closed && validAccountUrl($from.name)))) {
                        //if where they came from is good, stay there
                        return trans.router.stateService.target($from.name, trans.params('from'));
                    }
                    return trans.router.stateService.target('base.overview');
                }
            }
            return false;
        }

        function validClosedAccountUrl(path) {
            //white list
            return path.includes('base.overview')
                || path.includes('base.profile')
                || path.includes('base.invite')
                || path.includes('base.funding.activity')
                || path.includes('base.security-update')
                || path.includes('public.login')
                || path.includes('public.logout');
        }
        function validAccountUrl(path) {
            if (User.wbBeta) {
                return true;
            }
            //black list
            return !(
                   path.includes('base.milestone-mod.create.steps')
                || path.includes('base.invite')
                || path.includes('base.funding.transfer')
                || path.includes('base.funding.auto-deposit')
                || path.includes('base.profile.banks')
                || path.includes('base.profile.contact.phone')
                || path.includes('base.profile.contact.mail')
                || path.includes('base.profile.employer')
                || path.includes('base.formulas.wallet-edit')
                || path.includes('base.formulas.create')
            );
        }

        Display.setMenu(trans.$to().data.showMenu);


        if (   trans.$to().name === trans.$from().name
            && trans.params('to')['#'] !== trans.params('from')['#']) {
            //skip scrolling if it's the same page and hash has changed
        } else {
            angular.element("html, body").animate({scrollTop: 0}, 200);
        }

        //if the transition promise uses .finally(), an error will be thrown if not caught.
        //using onSuccess && onError in conjunction instead
        // trans.promise.finally(function() {
        //     // transitionFinally(trans);
        // }).catch(function(err) {
        //     debugger;
        // });
    });
    $transitions.onSuccess({}, function(trans) {
        transitionFinally(trans);
    });
    $transitions.onError({}, function(trans) {
        transitionFinally(trans);
    });
    function transitionFinally(trans) {
        $timeout(function() {
            var height, hash, el;
            Track.trackPage(trans);

            try {
                //scroll to hash if it matches something on the page
                height = angular.element("#" + trans.params('to')['#']).offset().top;
                angular.element("html, body").animate({ scrollTop: height - 80 }, 200);
            } catch (err) {
            }
        });
    }

    $rootScope.$on('AuthLoggedIn', function() {
        $q.when().then(function() {
            return User.getOverviewPromise();
        }).then(function() {
            var overview = User.getOverview();
        });
    });
    $rootScope.$on('AuthLoggedOut', function() {
    });


    $rootScope.wbBeta = "wbBeta" in $location.search();
    User.wbBeta = $rootScope.wbBeta;

    //assigning Display to rootscope for footer/sidebar/navigation
    $rootScope.Display = Display;

    $rootScope.$state = $state;
    $rootScope.$stateParams = $stateParams;
    $rootScope.$transitions = $transitions;
    $rootScope.Math = $window.Math;

    $rootScope.devDomain = CommonConstant.devDomains.includes($location.host());

}]);
